import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import sampleIcon from "../../img/certi-sample.png";
import "../../css/style.css";

//수료증 상세 보기
const CertificateIssue = () => {
  let { ce_idx } = useParams();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varCertificateInfo,setCertificateInfo] = useState({});
  const [varCerficationFile,setCerficationFile] = useState(sampleIcon);

  //수료증 상세 보기를 위한 정보 호출
  const GetCertificateIssue = async() => {
    const sendData = {ce_idx:ce_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_certificate_issue`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.certificates.length > 0) {
          const certificates = datas.certificates[0];
          if(certificates.ce_issue === 1) {
            setCerficationFile(`${process.env.REACT_APP_HOST}/certificate/${certificates.ce_file}`);
          }
          setCertificateInfo(certificates);
        }
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //서버로부터 정보 호출
    GetCertificateIssue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //수료증 국문/영문 선택
  const onCertificationHandler = async(e,ce_lang) => {
    const ch_idx = varCertificateInfo.ce_ch_idx;
    const vl_idx = varCertificateInfo.vl_idx;
    const sendData = {ch_idx:ch_idx,ce_lang:ce_lang,vl_idx:vl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_certificate_issue_lang`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.certificates.length === 0) {
          const sprompt = ce_lang===1?"국문":"영문";
          alert(`${sprompt}으로 발급된 수료증이 없습니다.`);
        } else {
          const certificates = datas.certificates[0];
          if(certificates.ce_issue === 1) {
            setCerficationFile(`${process.env.REACT_APP_HOST}/certificate/${certificates.ce_file}`);
          }
          setCertificateInfo(certificates);
        }
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'수료증 상세'} varBackString={'/Branch/CertificatesSet'}/>
      <div className="vh-content-body cl-certi-wrap">
        <div className="view-con">
          <div className="center-wrap">
            <div className="tab-wrap">
              <ul>
                <li className={varCertificateInfo.ce_lang===1?"active":""}>
                  <div onClick={e=>onCertificationHandler(e,1)}>국문</div>
                </li>
                <li className={varCertificateInfo.ce_lang===2?"active":""}>
                  <div onClick={e=>onCertificationHandler(e,2)}>영문</div>
                </li>
              </ul>
            </div>
            {/* 수료증 표시 */}
            <div className="img-box"><img src={varCerficationFile} alt="수료증" /></div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default CertificateIssue;